import { styled } from 'styled-components';
import { Popover } from '@mantine/core';
import { textSmallSemiBold } from '../../Typography';

export const PopoverContainer = styled(Popover)`
  /* Your styles here */
`;

export const DropdownContainer = styled(Popover.Dropdown)`
  background: var(--black-400);
  border-color: var(--border-color-default);
  padding: var(--space-150);
  border-radius: 8px;

  ul {
    display: flex;
    flex-direction: column;
    margin: 0;
    list-style-type: none;
    padding: 0;
    gap: var(--space-50);

    li {
      display: flex;
      align-items: center;
      padding: 0;
      margin: var(--space-100) 0;
      ${textSmallSemiBold};
      color: var(--text-standard-secondary);

      &:first-child, &:last-child {
        margin: 0;
      }

      svg path {
        stroke: var(--text-standard-secondary);
      }
    }
  }
`;
